module.exports = __webpack_public_path__ + "media/images/partner/supporter/onvista-9c182759458538d247aca1a045d3e6cc.jpg";